export default "__VITE_ASSET__DQjg4oK9__"